import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import PolygonExtracter from '../../geom/util/PolygonExtracter';
import OverlapUnion from './OverlapUnion';
import STRtree from '../../index/strtree/STRtree';
import Geometry from '../../geom/Geometry';
import hasInterface from '../../../../../hasInterface';
import GeometryFactory from '../../geom/GeometryFactory';
import Polygonal from '../../geom/Polygonal';
import ArrayList from '../../../../../java/util/ArrayList';
import List from '../../../../../java/util/List';
var CascadedPolygonUnion = /*#__PURE__*/function () {
  function CascadedPolygonUnion() {
    _classCallCheck(this, CascadedPolygonUnion);
    CascadedPolygonUnion.constructor_.apply(this, arguments);
  }
  _createClass(CascadedPolygonUnion, [{
    key: "reduceToGeometries",
    value: function reduceToGeometries(geomTree) {
      var geoms = new ArrayList();
      for (var i = geomTree.iterator(); i.hasNext();) {
        var o = i.next();
        var geom = null;
        if (hasInterface(o, List)) geom = this.unionTree(o);else if (o instanceof Geometry) geom = o;
        geoms.add(geom);
      }
      return geoms;
    }
  }, {
    key: "union",
    value: function union() {
      if (this._inputPolys === null) throw new IllegalStateException('union() method cannot be called twice');
      if (this._inputPolys.isEmpty()) return null;
      this._geomFactory = this._inputPolys.iterator().next().getFactory();
      var index = new STRtree(CascadedPolygonUnion.STRTREE_NODE_CAPACITY);
      for (var i = this._inputPolys.iterator(); i.hasNext();) {
        var item = i.next();
        index.insert(item.getEnvelopeInternal(), item);
      }
      this._inputPolys = null;
      var itemTree = index.itemsTree();
      var unionAll = this.unionTree(itemTree);
      return unionAll;
    }
  }, {
    key: "binaryUnion",
    value: function binaryUnion() {
      if (arguments.length === 1) {
        var geoms = arguments[0];
        return this.binaryUnion(geoms, 0, geoms.size());
      } else if (arguments.length === 3) {
        var _geoms = arguments[0],
          start = arguments[1],
          end = arguments[2];
        if (end - start <= 1) {
          var g0 = CascadedPolygonUnion.getGeometry(_geoms, start);
          return this.unionSafe(g0, null);
        } else if (end - start === 2) {
          return this.unionSafe(CascadedPolygonUnion.getGeometry(_geoms, start), CascadedPolygonUnion.getGeometry(_geoms, start + 1));
        } else {
          var mid = Math.trunc((end + start) / 2);
          var _g = this.binaryUnion(_geoms, start, mid);
          var g1 = this.binaryUnion(_geoms, mid, end);
          return this.unionSafe(_g, g1);
        }
      }
    }
  }, {
    key: "repeatedUnion",
    value: function repeatedUnion(geoms) {
      var union = null;
      for (var i = geoms.iterator(); i.hasNext();) {
        var g = i.next();
        if (union === null) union = g.copy();else union = union.union(g);
      }
      return union;
    }
  }, {
    key: "unionSafe",
    value: function unionSafe(g0, g1) {
      if (g0 === null && g1 === null) return null;
      if (g0 === null) return g1.copy();
      if (g1 === null) return g0.copy();
      return this.unionActual(g0, g1);
    }
  }, {
    key: "unionActual",
    value: function unionActual(g0, g1) {
      var union = OverlapUnion.union(g0, g1);
      return CascadedPolygonUnion.restrictToPolygons(union);
    }
  }, {
    key: "unionTree",
    value: function unionTree(geomTree) {
      var geoms = this.reduceToGeometries(geomTree);
      var union = this.binaryUnion(geoms);
      return union;
    }
  }, {
    key: "bufferUnion",
    value: function bufferUnion() {
      if (arguments.length === 1) {
        var geoms = arguments[0];
        var factory = geoms.get(0).getFactory();
        var gColl = factory.buildGeometry(geoms);
        var unionAll = gColl.buffer(0.0);
        return unionAll;
      } else if (arguments.length === 2) {
        var g0 = arguments[0],
          g1 = arguments[1];
        var _factory = g0.getFactory();
        var _gColl = _factory.createGeometryCollection([g0, g1]);
        var _unionAll = _gColl.buffer(0.0);
        return _unionAll;
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._inputPolys = null;
      this._geomFactory = null;
      var polys = arguments[0];
      this._inputPolys = polys;
      if (this._inputPolys === null) this._inputPolys = new ArrayList();
    }
  }, {
    key: "restrictToPolygons",
    value: function restrictToPolygons(g) {
      if (hasInterface(g, Polygonal)) return g;
      var polygons = PolygonExtracter.getPolygons(g);
      if (polygons.size() === 1) return polygons.get(0);
      return g.getFactory().createMultiPolygon(GeometryFactory.toPolygonArray(polygons));
    }
  }, {
    key: "getGeometry",
    value: function getGeometry(list, index) {
      if (index >= list.size()) return null;
      return list.get(index);
    }
  }, {
    key: "union",
    value: function union(polys) {
      var op = new CascadedPolygonUnion(polys);
      return op.union();
    }
  }]);
  return CascadedPolygonUnion;
}();
export { CascadedPolygonUnion as default };
CascadedPolygonUnion.STRTREE_NODE_CAPACITY = 4;